/**
 * Standardized input styling for date/time pickers across the app
 * Ensures consistent look and feel for all native date/time inputs
 */

/**
 * Standard date input styling (medium size)
 * Use for most date inputs
 */
export const DATE_INPUT_CLASS =
  'px-3 py-2 text-sm rounded-lg border border-neutral-200 bg-white ' +
  'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent ' +
  'transition-colors'

/**
 * Standard time input styling (medium size)
 * Use for most time inputs
 */
export const TIME_INPUT_CLASS =
  'px-3 py-2 text-sm rounded-lg border border-neutral-200 bg-white ' +
  'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent ' +
  'transition-colors'

/**
 * Compact date input styling (small size)
 * Use in tight spaces or inline contexts
 */
export const DATE_INPUT_COMPACT_CLASS =
  'px-2 py-1.5 text-xs rounded border border-neutral-200 bg-white ' +
  'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent ' +
  'transition-colors'

/**
 * Compact time input styling (small size)
 * Use in tight spaces or inline contexts
 */
export const TIME_INPUT_COMPACT_CLASS =
  'px-2 py-1.5 text-xs rounded border border-neutral-200 bg-white ' +
  'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent ' +
  'transition-colors'

/**
 * Large date input styling
 * Use in prominent forms (e.g., RoutineForm)
 */
export const DATE_INPUT_LARGE_CLASS =
  'px-4 py-3 text-base rounded-xl border border-neutral-200 bg-white ' +
  'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent ' +
  'transition-colors'

/**
 * Large time input styling
 * Use in prominent forms (e.g., RoutineForm)
 */
export const TIME_INPUT_LARGE_CLASS =
  'px-4 py-3 text-base rounded-xl border border-neutral-200 bg-white ' +
  'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent ' +
  'transition-colors'
